import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Logo from "@/components/common/Logo";
import ThemeToggle from "@/components/ui/ThemeToggle";
import AuthShowcase from "./AuthShowcase";

// Split auth shell: branded visual panel (left) + form (right). Visual panel
// collapses on small screens so the form is always front-and-center.
export default function AuthLayout({ title, subtitle, children }) {
  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-ink-950">
      {/* visual panel — calm deep-navy with soft glows + animated showcase */}
      <div className="relative hidden w-1/2 overflow-hidden bg-gradient-to-br from-ink-950 via-[#151935] to-ink-950 lg:flex">
        {/* faint grid */}
        <div className="absolute inset-0 bg-grid-dark bg-[size:34px_34px] [mask-image:radial-gradient(ellipse_at_center,black,transparent_75%)]" />
        {/* soft, low-saturation glows */}
        <div className="pointer-events-none absolute -left-24 top-8 h-80 w-80 animate-blob rounded-full bg-brand-500/20 blur-3xl" />
        <div className="pointer-events-none absolute bottom-0 right-0 h-96 w-96 animate-blob rounded-full bg-violet-500/10 blur-3xl [animation-delay:4s]" />
        <div className="pointer-events-none absolute left-1/2 top-1/3 h-64 w-64 animate-blob rounded-full bg-sky-500/10 blur-3xl [animation-delay:7s]" />

        <AuthShowcase />
      </div>

      {/* form panel */}
      <div className="relative flex w-full items-center justify-center px-5 py-12 lg:w-1/2">
        <div className="absolute right-5 top-5">
          <ThemeToggle />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-md"
        >
          {/* logo on mobile (visual panel hidden) */}
          <Link to="/" className="mb-8 inline-flex lg:hidden">
            <Logo />
          </Link>

          {/* Optional: a step that owns its own heading (the OTP panel, which
              crossfades its title on success) passes neither, and shouldn't get
              an empty <h1> reserving space above it. */}
          {title && (
            <h1 className="font-display text-2xl font-bold text-slate-900 dark:text-white sm:text-3xl">
              {title}
            </h1>
          )}
          {subtitle && (
            <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
              {subtitle}
            </p>
          )}

          <div className={title || subtitle ? "mt-8" : ""}>{children}</div>
        </motion.div>
      </div>
    </div>
  );
}
